import CryptoJS from 'crypto-js';

function deriveWrapKey(publicKeyBase64: string, senderKeyId: string): CryptoJS.lib.WordArray {
  return CryptoJS.SHA256(`${publicKeyBase64}:${senderKeyId}`);
}

export function unwrapContentKeyForRecipient(args: {
  recipientPublicKeyBase64: string;
  senderKeyId: string;
  wrappedKeyBase64: string;
}): string {
  const parts = String(args.wrappedKeyBase64 || '').split('.');
  if (parts.length !== 2) throw new Error('invalid_wrapped_key_format');

  const iv = CryptoJS.enc.Base64.parse(parts[0]);
  const ciphertext = CryptoJS.enc.Base64.parse(parts[1]);
  const wrapKey = deriveWrapKey(args.recipientPublicKeyBase64, args.senderKeyId);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext } as any,
    wrapKey,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );

  const out = CryptoJS.enc.Utf8.stringify(decrypted);
  if (!out) throw new Error('unwrap_failed');
  return out;
}
